import SvgLogoBig from "../svg/SvgLogoBig";
import {useEffect, useRef} from "react";
import {mapNumber} from "../helpers/numbers";

export default function FadingLogo() {

    const refLogo = useRef();

    useEffect(() => {
        const handleScroll = () => {
            if (refLogo.current) {
                const winHeight = window.innerHeight;
                const nowScroll = refLogo.current.getBoundingClientRect().y - winHeight;

                let opacity;

                if (nowScroll > winHeight / -2) {
                    opacity = mapNumber(nowScroll, 0, winHeight / -2, 0, 1, false);
                } else {
                    opacity = mapNumber(nowScroll, winHeight / -2, -winHeight, 1, 0, false);
                }

                refLogo.current.style.opacity = Math.min(Math.max(opacity, 0), 1);
            }
        }

        window?.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window?.removeEventListener('scroll', handleScroll)
    }, []);

    return (
        <div className="relative left-1/4 w-full max-w-[100rem] text-gray-100" ref={refLogo}>
            <SvgLogoBig id="fading-logo"/>
        </div>
    )
}
